export function normalizePath() {
    const { pathname, search, hash } = window.location;
    if (pathname.includes('//')) {
      const normalizedPath = pathname.replace(/\/{2,}/g, '/');
      const newUrl = normalizedPath + search + hash;
      window.history.replaceState(null, '', newUrl);
    }
  }